import { Route, Routes } from "react-router-dom";
import { PTLI0916001Q } from "@/tra/tancis/ptli/usr/org/PTLI0916001Q";
import { PTLI0916002S } from "@/tra/tancis/ptli/usr/org/PTLI0916002S";
import { PTLI0916003S } from "@/tra/tancis/ptli/usr/org/PTLI0916003S";
import { PTLI0916004Q } from "@/tra/tancis/ptli/usr/org/PTLI0916004Q";
import { PTLI0917001Q } from "@/tra/tancis/ptli/usr/orgusr/PTLI0917001Q";
import { PTLI0917002S } from "@/tra/tancis/ptli/usr/orgusr/PTLI0917002S";
import { PTLI0917003S } from "@/tra/tancis/ptli/usr/orgusr/PTLI0917003S";
import { PTLI0917004Q } from "@/tra/tancis/ptli/usr/orgusr/PTLI0917004Q";

import { PTLI0901001Q } from "@/tra/tancis/ptli/usr/cstm/PTLI0901001Q";
import { PTLI0901002S } from "@/tra/tancis/ptli/usr/cstm/PTLI0901002S";
import { PTLI0901004Q } from "@/tra/tancis/ptli/usr/cstm/PTLI0901004Q";
import { PTLI0901003S } from "@/tra/tancis/ptli/usr/cstm/PTLI0901003S";
import { PTLI0902001Q } from "@/tra/tancis/ptli/usr/cstmofcr/PTLI0902001Q";
import { PTLI0902002S } from "@/tra/tancis/ptli/usr/cstmofcr/PTLI0902002S";
import { PTLI0902003S } from "@/tra/tancis/ptli/usr/cstmofcr/PTLI0902003S";
import { PTLI0902004Q } from "@/tra/tancis/ptli/usr/cstmofcr/PTLI0902004Q";
import { PTLI0912001Q } from "@/tra/tancis/ptli/usr/orgz/PTLI0912001Q";
// import { PTLI0903002S } from "@/tra/tancis/ptli/usr/cstmofcr/PTLI0902002S";
import { PTLI0904001Q } from "@/tra/tancis/ptli/usr/ofcrhist/PTLI0904001Q";
import { PTLI0904002Q } from "@/tra/tancis/ptli/usr/ofcrhist/PTLI0904002Q";
import { PTLI0906001Q } from "@/tra/tancis/ptli/usr/lcneusr/PTLI0906001Q";
import { PTLI0906002S } from "@/tra/tancis/ptli/usr/lcneusr/PTLI0906002S";
import { PTLI0906003S } from "@/tra/tancis/ptli/usr/lcneusr/PTLI0906003S";
import { PTLI0906004Q } from "@/tra/tancis/ptli/usr/lcneusr/PTLI0906004Q";
import { PTLI0907001Q } from "@/tra/tancis/ptli/usr/lcneusraprv/PTLI0907001Q";
import { PTLI0907002Q } from "@/tra/tancis/ptli/usr/lcneusraprv/PTLI0907002Q";
import { PTLI0915001Q } from "@/tra/tancis/ptli/usr/coaprv/PTLI0915001Q";
import { PTLI0915002S } from "@/tra/tancis/ptli/usr/coaprv/PTLI0915002S";

import { PTLI0918001Q } from "@/tra/tancis/ptli/usr/sctn/PTLI0918001Q";
import { PTLI0918002S } from "@/tra/tancis/ptli/usr/sctn/PTLI0918002S";
import { PTLI0918003Q } from "@/tra/tancis/ptli/usr/sctn/PTLI0918003Q";
import { PTLI0918004S } from "@/tra/tancis/ptli/usr/sctn/PTLI0918004S";
import { PTLI0920001Q } from "@/tra/tancis/ptli/usr/bidraprv/PTLI0920001Q";
import { PTLI0920002S } from "@/tra/tancis/ptli/usr/bidraprv/PTLI0920002S";

import { PTLI0919001S } from "@/tra/tancis/ptli/usr/frgnr/PTLI0919001S";
import { PTLI0919002S } from "@/tra/tancis/ptli/usr/frgnr/PTLI0919002S";
import { PTLI0919003S } from "@/tra/tancis/ptli/usr/frgnr/PTLI0919003S";
import { PTLI0919006S } from "@/tra/tancis/ptli/usr/frgnr/PTLI0919006S";

import { PTLI0407001Q } from "@/tra/tancis/ptli/usr/cocd/PTLI0407001Q";
import { PTLI0407002S } from "@/tra/tancis/ptli/usr/cocd/PTLI0407002S";
import { PTLI0407003S } from "@/tra/tancis/ptli/usr/cocd/PTLI0407003S";
import { PTLI0911001Q } from "@/tra/tancis/ptli/usr/bidrusr/PTLI0911001Q";
import { PTLI0911002S } from "@/tra/tancis/ptli/usr/bidrusr/PTLI0911002S";
import { PTLI0911003S } from "@/tra/tancis/ptli/usr/bidrusr/PTLI0911003S";
import { PTLI0911004Q } from "@/tra/tancis/ptli/usr/bidrusr/PTLI0911004Q";

import { PTLI0905001Q } from "@/tra/tancis/ptli/usr/co/PTLI0905001Q";
import { PTLI0905002S } from "@/tra/tancis/ptli/usr/co/PTLI0905002S";
import { PTLI0905003S } from "@/tra/tancis/ptli/usr/co/PTLI0905003S";
import { PTLI0905004Q } from "@/tra/tancis/ptli/usr/co/PTLI0905004Q";

import { PTLI0921001Q } from "@/tra/tancis/ptli/usr/orgusraprv/PTLI0921001Q";
import { PTLI0921002S } from "@/tra/tancis/ptli/usr/orgusraprv/PTLI0921002S";

import { PTLI0922001Q } from "@/tra/tancis/ptli/usr/xtrnusr/PTLI0922001Q";
import { PTLI0922002S } from "@/tra/tancis/ptli/usr/xtrnusr/PTLI0922002S";
import { PTLI0922003S } from "@/tra/tancis/ptli/usr/xtrnusr/PTLI0922003S";
import { PTLI0922004Q } from "@/tra/tancis/ptli/usr/xtrnusr/PTLI0922004Q";

import { PTLI0923001Q } from "@/tra/tancis/ptli/usr/xtrnusrhist/PTLI0923001Q";
import { PTLI0923002Q } from "@/tra/tancis/ptli/usr/xtrnusrhist/PTLI0923002Q";

import { PTLI0924001Q } from "@/tra/tancis/ptli/usr/extauth/PTLI0924001Q";
import { PTLI0924002S } from "@/tra/tancis/ptli/usr/extauth/PTLI0924002S";
/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 * TODO URL의 'key' 를 실제 ID로 변경 하세요.
 * TODO 위의 한글 주석은 마지막에 전부 삭제하세요.
 */
export const UsrRouter = () => {
    return (
        <Routes>
            {/** ==================== Organization Management Router START ==================== */}

            {/* Organization Management List !== 기관 관리 목록 ==! */}
            <Route path={"/org/ptli0916001q"} element={<PTLI0916001Q />} />

            {/* Organization Management Registration !== 기관 관리 등록 ==! */}
            <Route path={"/org/ptli0916002s"} element={<PTLI0916002S />} />

            {/* Organization Management Change !== 기관 관리 수정 ==! */}
            <Route path={"/org/ptli0916003s/:orgCd"} element={<PTLI0916003S />} />

            {/* Organization Management Detail !== 기관 관리 상세 ==! */}
            <Route path={"/org/ptli0916004q/:orgCd"} element={<PTLI0916004Q />} />

            {/** ==================== Organization Management Router END ==================== */}

            {/** ==================== Organization User Management Router START ==================== */}

            {/* Organization User Management List !== 기관 사용자 관리 목록 ==! */}
            <Route path={"/orgusr/ptli0917001q"} element={<PTLI0917001Q />} />
            {/* Organization User Management Registration !== 기관 사용자 관리 등록 ==! */}
            <Route path={"/orgusr/ptli0917002s"} element={<PTLI0917002S />} />
            {/* Organization User Management Change !== 기관 사용자 관리 수정 ==! */}
            <Route path={"/orgusr/ptli0917003s/:xtrnUsrUuid"} element={<PTLI0917003S />} />
            {/* Organization User Management Detail !== 기관 사용자 관리 상세 ==! */}
            <Route path={"/orgusr/ptli0917004q/:xtrnUsrUuid"} element={<PTLI0917004Q />} />
            {/** ==================== Organization User Management Router END ==================== */}

            {/** ==================== Customs Management Router START ==================== */}

            {/* Customs List !== 세관 목록 ==! */}
            <Route path={"/cstm/ptli0901001q"} element={<PTLI0901001Q />} />

            {/* Customs List !== 세관 등록 ==! */}
            <Route path={"/cstm/ptli0901002s"} element={<PTLI0901002S />} />

            {/* Edit customs information !== 세관 정보 수정 ==! */}
            <Route path={"/cstm/ptli0901003s/:cstmOfceCd"} element={<PTLI0901003S />} />

            {/* Customs details inquiry !== 세관 상세 정보 조회 ==! */}
            <Route path={"/cstm/ptli0901004q/:cstmOfceCd"} element={<PTLI0901004Q />} />

            {/** ==================== Customs Management Router END ==================== */}

            {/** ==================== Customs Officer management Router START ==================== */}

            {/* Customs Officer management List !== 세관 직원 관리 목록 ==! */}
            <Route path={"/cstmofcr/ptli0902001q"} element={<PTLI0902001Q />} />

            {/* Customs Officer management List !== 세관 직원 관리 등록 ==! */}
            <Route path={"/cstmofcr/ptli0902002s"} element={<PTLI0902002S />} />

            {/* Edit Customs Officer management !== 세관 직원 관리 수정 ==! */}
            <Route path={"/cstmofcr/ptli0902003s/:usrDmnId"} element={<PTLI0902003S />} />

            {/* Customs Officer management details inquiry !== 세관 직원 관리 정보 조회 ==! */}
            <Route path={"/cstmofcr/ptli0902004q/:usrDmnId"} element={<PTLI0902004Q />} />

            {/** ==================== Customs Officer management Router END ==================== */}

            {/** ==================== Customs Officer Management Router START ==================== */}

            {/* Inquiry of Customs Employee Application Information !== 세관 직원 신청 정보 조회 ==! */}
            {/* <Route path={"/cstmofcr/ptli0903002s/:intUsrAplyId"} element={<PTLI0903002S />} /> */}

            {/** ==================== Customs Officer Management Router END ==================== */}

            {/** ==================== Customs Officer Change History Management Router START ==================== */}

            {/* Inquiry into detailed information of customs employee application !== 세관직원변경이력 조회==! */}
            <Route path={"/ofcrhist/ptli0904001q"} element={<PTLI0904001Q />} />

            {/* Inquiry into detailed information of customs employee application !== 세관직원변경이력 상세 조회==! */}
            <Route path={"/ofcrhist/ptli0904002q/:usrDmnId"} element={<PTLI0904002Q />} />

            {/** ==================== Customs Officer Change History Management Router END ==================== */}

            {/** ==================== Section Management Router START ==================== */}

            {/* Section List !== 섹션 목록 ==! */}
            <Route path={"/sctn/ptli0918001q"} element={<PTLI0918001Q />} />
            {/* Section Registration !== 섹션 등록 ==! */}
            <Route path={"/sctn/ptli0918002s"} element={<PTLI0918002S />} />
            {/* Section Details !== 섹션 정보 상세 ==! */}
            <Route path={"/sctn/ptli0918003q/:cstmOrgzCd"} element={<PTLI0918003Q />} />
            {/* Section Details !== 섹션 정보 수정 ==! */}
            <Route path={"/sctn/ptli0918004s/:cstmOrgzCd"} element={<PTLI0918004S />} />

            {/** ==================== Section Management Router END ==================== */}

            {/* Organizations List !== 조직 목록 ==! */}
            <Route path={"/orgz/ptli0912001q"} element={<PTLI0912001Q />} />

            {/** ==================== Company Approval Request Router START ==================== */}

            {/* Inquiry of Company Approval Request List !== 업체 승인 요청 목록 조회 ==! */}
            <Route path={"/coaprv/ptli0915001q"} element={<PTLI0915001Q />} />

            {/* Company Approval Request Details !== 업체 승인 요청 상세 ==! */}
            <Route path={"/coaprv/ptli0915002s/:xtrnUsrAplyId"} element={<PTLI0915002S />} />

            {/** ==================== Company Approval Request Router END ==================== */}

            {/** ==================== Company Management Router START ==================== */}

            {/* Inquiry of Company Approval Request List !== 업체 관리 목록 조회 ==! */}
            <Route path={"/co/ptli0905001q"} element={<PTLI0905001Q />} />

            {/* Company Registration !== 업체 등록 ==! */}
            <Route path={"/co/ptli0905002s"} element={<PTLI0905002S />} />

            {/* Company Modification !== 업체 수정 ==! */}
            <Route path={"/co/ptli0905003s/:coTin"} element={<PTLI0905003S />} />

            {/* Company Details !== 업체 상세 ==! */}
            <Route path={"/co/ptli0905004q/:coTin"} element={<PTLI0905004Q />} />

            {/** ==================== Company Management Router END ==================== */}

            {/** ==================== License User Router START ==================== */}

            {/* Inquiry of License User Apply Information !== 면허 사용자 신청 정보 조회 ==! */}
            <Route path={"/lcneusr/ptli0906001q"} element={<PTLI0906001Q />} />

            {/* License User Registration !== 면허 사용자 등록 ==! */}
            <Route path={"/lcneusr/ptli0906002s"} element={<PTLI0906002S />} />

            {/* License User Change !== 면허 사용자 수정 ==! */}
            <Route path={"/lcneusr/ptli0906003s/:lcneCoAplyId"} element={<PTLI0906003S />} />

            {/* License User Details !== 면허 사용자 상세 ==! */}
            <Route path={"/lcneusr/ptli0906004q/:lcneCoAplyId"} element={<PTLI0906004Q />} />

            {/* Inquiry of License User Apply Approval List !== 면허 사용자 신청 승인 목록 조회 ==! */}
            <Route path={"/lcneusraprv/ptli0907001q"} element={<PTLI0907001Q />} />

            {/* License User Details !== 면허 사용자 상세 ==! */}
            <Route path={"/lcneusraprv/ptli0907002q/:lcneCoAplyId"} element={<PTLI0907002Q />} />

            {/** ==================== License User Router END ==================== */}

            {/** ==================== Bidder Approval Request Router START ==================== */}

            {/* Inquiry of Bidder Approval Request List !== 공매자 승인 요청 목록 조회 ==! */}
            <Route path={"/bidraprv/ptli0920001q"} element={<PTLI0920001Q />} />

            {/* Bidder Approval Request Details !== 공매자 승인 요청 상세 ==! */}
            <Route path={"/bidraprv/ptli0920002s/:xtrnUsrAplyId"} element={<PTLI0920002S />} />

            {/** ==================== Bidder Approval Request Router END ==================== */}

            {/** ====================Foreign Transporter Router START ==================== */}
            <Route path={"/frgnr/ptli0919001s"} element={<PTLI0919001S />} />
            <Route path={"/frgnr/ptli0919002s"} element={<PTLI0919002S />} />
            <Route path={"/frgnr/ptli0919003s/:coTin"} element={<PTLI0919003S />} />
            <Route path={"/frgnr/ptli0919006s/:coTin"} element={<PTLI0919006S />} />
            {/** ====================Foreign Transporter Router END ==================== */}

            {/** ==================== Company Code Management Router START ==================== */}

            {/* Inquiry of Company Code List !== 업체 코드 목록 조회 ==! */}
            <Route path={"/cocd/ptli0407001q"} element={<PTLI0407001Q />} />

            {/* Inquiry of Company Code List !== 업체 코드 등록 ==! */}
            <Route path={"/cocd/ptli0407002s"} element={<PTLI0407002S />} />

            {/* Inquiry of Company Code Modification !== 업체 코드 수정 ==! */}
            <Route path={"/cocd/ptli0407003s/:coTin/:coSn"} element={<PTLI0407003S />} />

            {/** ==================== Company Code Management Router END ==================== */}

            {/** ==================== Bidder User Management Router START ==================== */}

            {/* Inquiry of Bidder User Management List !== 공매자 관리 목록 조회 ==! */}
            <Route path={"/bidrusr/ptli0911001q"} element={<PTLI0911001Q />} />
            <Route path={"/bidrusr/ptli0911002s"} element={<PTLI0911002S />} />
            <Route path={"/bidrusr/ptli0911003s/:xtrnUsrUuid"} element={<PTLI0911003S />} />
            <Route path={"/bidrusr/ptli0911004q/:xtrnUsrUuid"} element={<PTLI0911004Q />} />

            {/** ==================== Bidder User Management Router END ==================== */}

            {/** ==================== Organization User Management Router START ==================== */}

            {/* Organization User Approve Management List !== 기관 사용자 신청 관리 목록 ==! */}
            <Route path={"/orgusraprv/ptli0921001q"} element={<PTLI0921001Q />} />
            <Route path={"/orgusraprv/ptli0921002s/:xtrnUsrUuid"} element={<PTLI0921002S />} />
            {/** ==================== Organization User Management Router END ==================== */}

            {/** ==================== External User Management Router START ==================== */}

            {/* External User Management List !== 외부 사용자 관리 목록 ==! */}
            <Route path={"/xtrnusr/ptli0922001q"} element={<PTLI0922001Q />} />

            {/* External User Registration !== 외부 사용자 등록 ==! */}
            <Route path={"/xtrnusr/ptli0922002s"} element={<PTLI0922002S />} />

            {/* External User Modification !== 외부 사용자 수정 ==! */}
            <Route path={"/xtrnusr/ptli0922003s/:xtrnUsrUuid"} element={<PTLI0922003S />} />

            {/* External User Details !== 외부 사용자 상세 ==! */}
            <Route path={"/xtrnusr/ptli0922004q/:xtrnUsrUuid"} element={<PTLI0922004Q />} />
            {/** ==================== External User Management Router END ==================== */}

            {/* External user change history list !== 외부사용자 변경이력 목록 ==! */}
            <Route path={"/xtrnusrhist/ptli0923001q"} element={<PTLI0923001Q />} />

            {/* Detailed list of external user change history !== 외부사용자 변경이력 상세 목록 ==! */}
            <Route path={"/xtrnusrhist/ptli0923002q/:xtrnUsrIdntfNo/:lcneUsrYn"} element={<PTLI0923002Q />} />

            {/* External user Authority list !== 외부사용자 권한 목록 ==! */}
            <Route path={"/extauth/ptli0924001q"} element={<PTLI0924001Q />} />
            <Route path={"/extauth/ptli0924002s/:xtrnUsrUuid"} element={<PTLI0924002S />} />
        </Routes>
    );
};
